import React, { useState, useContext } from "react"
import VisibilitySensor from "react-visibility-sensor"
import { UIContext } from "../shared/layout"

const VisibilityProvider = ({
  children,
  className,
  fullyVisible = false,
  onChange = () => {},
}) => {
  const [isVisible, _setIsVisible] = useState(false)
  const {
    state: { disableAnimations },
  } = useContext(UIContext)

  const setIsVisible = state => {
    if (state) {
      onChange(state)
      _setIsVisible(state)
    }
  }

  const element = React.cloneElement(React.Children.toArray(children)[0], {
    isVisible,
    disableAnimations,
    className,
  })

  return (
    <VisibilitySensor
      partialVisibility={!fullyVisible}
      onChange={setIsVisible}
      delayedCall={true}
    >
      {element}
    </VisibilitySensor>
  )
}

export default VisibilityProvider
